var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3f46c58e8ced8e5bfdc4131c914fa345e297513c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mubazar-frontend@mubazar"]={id:"3f46c58e8ced8e5bfdc4131c914fa345e297513c"};
      